import { environment } from "../../../config/appConfig";

const TestSiteKey = "1x00000000000000000000AA";

const SITE_KEY_1 = "0x4AAAAAACIPiLBsveb8CYSz";
const SITE_KEY_2 = "0x4AAAAAACIPiLBsveb8CY";

type DomainConfig = {
    siteKey1: string[];
    siteKey2: string[];
};

const DOMAIN_CONFIG: Record<string, DomainConfig> = {
    staging: {
        siteKey1: [
            "https://react-sky.beta.sky365.mobi",
        ],
        siteKey2: [],
    },
    production: {
        siteKey1: [],
        siteKey2: [],
    }
};

const getDomainSets = (env: string) => {
    const config = DOMAIN_CONFIG[env] || DOMAIN_CONFIG.development;

    return {
        siteKey1Set: new Set<string>(config.siteKey1),
        siteKey2Set: new Set<string>(config.siteKey2),
    };
};

export const getTurnstileSiteKey = (): string => {
    const { protocol, hostname, port } = window.location;



    const domain = port
        ? `${protocol}//${hostname}:${port}`
        : `${protocol}//${hostname}`;

    console.log(domain);

    if (hostname === "localhost" || environment === "development") {
        return TestSiteKey;
    }

    const { siteKey1Set, siteKey2Set } = getDomainSets(environment);

    if (siteKey1Set.has(domain)) {
        return SITE_KEY_1;
    }

    if (siteKey2Set.has(domain)) {
        return SITE_KEY_2;
    }

    console.warn(`Unknown domain (${environment}):`, domain);

    return SITE_KEY_1;
};